import { jsx as _jsx } from "react/jsx-runtime";
import { FactionListEntry } from './FactionListEntry.js';
import { IconList } from './IconList.js';
export function FactionList(props) {
    const { title, factions, onClick, button, dense } = props;
    return (_jsx(IconList, { title: title, dense: dense, children: factions.map((factionName) => (_jsx(FactionListEntry, { factionName: factionName, onClick: onClick ? () => onClick(factionName) : undefined, button: button, dense: dense }, factionName))) }));
}
//# sourceMappingURL=FactionList.js.map